module.exports = __webpack_public_path__ + "img/serfaus.b67939a7.png";